export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGIN = 'LOGIN';
export const LOGIN_OAUTH_REQUEST = 'LOGIN_OAUTH_REQUEST';
export const LOGIN_OAUTH_FAILED = 'LOGIN_OAUTH_FAILED';
export const LOGIN_OAUTH = 'LOGIN_OAUTH';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';
export const LOGOUT = 'LOGOUT';
export const RESET_CACHE = 'RESET_CACHE';
